import { render, staticRenderFns } from "./ElderlyOrderMonthPie.vue?vue&type=template&id=1e867666&scoped=true&"
import script from "./ElderlyOrderMonthPie.vue?vue&type=script&lang=js&"
export * from "./ElderlyOrderMonthPie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e867666",
  null
  
)

export default component.exports